import { render, staticRenderFns } from "./GoogleButtonV2.vue?vue&type=template&id=d476b096&scoped=true&"
import script from "./GoogleButtonV2.vue?vue&type=script&lang=js&"
export * from "./GoogleButtonV2.vue?vue&type=script&lang=js&"
import style0 from "./GoogleButtonV2.vue?vue&type=style&index=0&id=d476b096&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d476b096",
  null
  
)

export default component.exports